// removed by extract-text-webpack-plugin
module.exports = {"component":"NvqvQFtEgwmdR2SkZDVwo","img":"_8uZEITOYOc5xCJu4HR2lJ","big":"_1NAQaIAVbL5pN40HOAgjS2","qrCode":"_1DNZWNZ10e4tW2ZUjIRDqp","back":"_1ena7aFsM1SwhHBkSldRLh","center":"uCbaN-cl60Mq4xmEFJ_M3","txt":"_3KBZAk0EDgahay5hchUl65","left":"_2X3BE3ifs3_eGQfbFaEVI0","right":"_1bHsebSZvdBClp7Y1KH_US","box":"zMTKIGKWEq_SJCqnDFWMa","span":"VrEo1kopLDdV-b7EYAnlD","mr0":"_2WrKsQ8YKDakAbwvFbefpY"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/FidelitySearchComponent/FidelitySearchComponent.scss
 ** module id = 967
 ** module chunks = 0
 **/